import React from 'react'
import './style.css'
import { LoremIpsum } from 'react-lorem-ipsum';
import FAQICON from '../../assets/icons/faq-sicon.svg';

const FAQ = () => {
  return (
    <div className="faq_question_section">
      <div className="faq-question">
      <img
                        loading="lazy"
                        alt="icon"
                        src={FAQICON} // Use src instead of srcSet if you're not using multiple image sources
                        style={{ height: '80px', width: '80px', alignItems:'center'}} // Set height and width to adjust the size of the image
                        />
        
        <LoremIpsum avgWordsPerSentence={1} /></div>
      <br/>
      <div className="faq-question-answer"><LoremIpsum p={1} /></div>
    </div>
  )
}

export default FAQ
